import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Plus, Calendar } from 'lucide-react';

interface ClientNotesProps {
  clientId: string;
}

export function ClientNotes({ clientId }: ClientNotesProps) {
  const notes = [
    {
      id: 1,
      date: '2024-03-10',
      content: 'Showed significant improvement in squat form. Increased weight by 5kg.',
      type: 'progress'
    },
    {
      id: 2,
      date: '2024-03-08',
      content: 'Reported mild shoulder discomfort. Modified chest exercises accordingly.',
      type: 'health'
    },
    {
      id: 3,
      date: '2024-03-06',
      content: 'Discussed nutrition plan adjustments. Increasing protein intake recommended.',
      type: 'nutrition'
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold">Session Notes</h2>
        </div>
        <button className="theme-button px-3 py-1.5 rounded-lg text-sm flex items-center gap-1">
          <Plus className="w-4 h-4" />
          Add Note
        </button>
      </div>

      <div className="space-y-4">
        {notes.map((note, index) => (
          <motion.div
            key={note.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg"
          >
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Calendar className="w-4 h-4" />
              <span>{note.date}</span>
            </div>
            <p className="text-sm">{note.content}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}